export const splitCategories = (categorias = []) => {
  const newCategorias = [];
  for (let i = 0; i < categorias?.length; i += 2) {
    newCategorias.push([categorias?.[i], categorias?.[i + 1]]);
  }
  return newCategorias;
};
